import styled from "styled-components";

interface Props {
    onChange?: (value: string) => void;
    placeholder?: string;
    type?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    ref?: React.Ref<HTMLInputElement>;
    onReturnPress?: () => void;
}

const InputContainer = styled.input`
    background-color: transparent;
    outline: none;
    border: none;
    font-size: 1.1rem;
    margin: 0.2rem 0.5rem;
    padding: 0.2rem;
    color: #f2f2f2;
    border-bottom: #f2f2f2 solid 1px;

    &:focus {
        border-bottom-color: var(--primary-color);
    }
`;

export default function Input({
    onChange = () => {},
    placeholder = '',
    type = 'text',
    disabled = false,
    autoFocus = false,
    onReturnPress = () => {},
    ref
}: Props) {
    return (
        <InputContainer
            type={type}
            ref={ref}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            autoFocus={autoFocus}
            onKeyDown={(ev) => {
                if (ev.key === 'Enter') {
                    ev.preventDefault();
                    onReturnPress();
                }
            }}
        />
    );
}